import { Model } from '@danangelus/ngx-app-core';

/**
 * PermissionGroup is a model that represents a reference to a group against an application or page in the database
 */
export class PermissionGroup extends Model {
    name: string | undefined
    fullDn: string | undefined

    constructor(name: string | undefined, fullDn: string | undefined) {
        super()

        this.fullDn = fullDn
        this.name = name
    }
}
